module.exports = __webpack_public_path__ + "img/seven3Orange.fc520661.jpg";